import React, { useEffect, useState } from "react";
import { fetchClientes } from "../../../integration/historico_clientes/fetchClientes";
import { BiRefresh } from "react-icons/bi";
import { formatToCPFOrCNPJ, formatToPhone } from "brazilian-values";

const ClientesTabela = () => {
  const [clientes, setClientes] = useState([]);
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [totalPaginas, setTotalPaginas] = useState(1);
  const [totalRegistros, setTotalRegistros] = useState(0);
  const [carregando, setCarregando] = useState(false);
  const itensPorPagina = 10;

  const funcClientes = async () => {
    setCarregando(true);
    try {
      const resposta = await fetchClientes({ paginaAtual, itensPorPagina });

      // Ajuste aqui para o formato da resposta
      const { data, total, page, pages } = resposta;

      setClientes(data || []);
      setTotalRegistros(total || 0);
      setTotalPaginas(pages || 1);
      setPaginaAtual(page || 1);
    } catch (erro) {
      console.error("Erro ao buscar clientes:", erro);
      setClientes([]);
      setTotalRegistros(0);
      setTotalPaginas(1);
    } finally {
      setCarregando(false);
    }
  };

  useEffect(() => {
    funcClientes();
  }, [paginaAtual]);

  return (
    <div className="w-full max-w-7xl mx-auto p-6 bg-[#fcfcfd] rounded-2xl">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
        <h2 className="text-3xl font-light text-[#0c0c0c]">Clientes</h2>
        <span className="text-gray-500 text-sm">
          Total: <strong>{totalRegistros}</strong> registros
        </span>
      </div>

      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
        <button
          onClick={() => funcClientes()}
          className="inline-flex items-center gap-2 px-5 py-2 bg-[#f5f4f1] text-gray-700 font-medium rounded-lg border border-gray-300 hover:bg-gray-100 transition"
        >
          <BiRefresh className="w-5 h-5" />
          Atualizar Histórico
        </button>
      </div>

      {/* Tabela */}
      <div className="overflow-x-auto rounded-xl border border-gray-200">
        <table className="min-w-full divide-y divide-gray-200 text-sm text-gray-700">
          <thead className="bg-[#f5f4f1] text-gray-700 font-semibold">
            <tr>
              {["Nome", "Telefone", "Email", "Documento"].map((title) => (
                <th key={title} className="px-4 py-3 text-left">
                  {title}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-100">
            {carregando ? (
              <tr>
                <td colSpan={4} className="text-center py-4 text-gray-500">
                  Carregando...
                </td>
              </tr>
            ) : clientes.length > 0 ? (
              clientes.map((cliente) => (
                <tr
                  key={
                    cliente.document?.number ||
                    cliente.document ||
                    cliente.email
                  }
                  className="hover:bg-gray-50 transition"
                >
                  <td className="px-4 py-3">{cliente.name}</td>
                  <td className="px-4 py-3">{formatToPhone(cliente.phone)}</td>
                  <td className="px-4 py-3">{cliente.email}</td>
                  <td className="px-4 py-3">
                    {formatToCPFOrCNPJ(
                      typeof cliente.document === "string"
                        ? cliente.document
                        : cliente.document?.number || ""
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={4} className="text-center py-4 text-gray-500">
                  Nenhum cliente encontrado.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Paginação */}
      <div className="mt-6 flex justify-between items-center text-sm text-gray-700">
        <div>
          Página <strong>{paginaAtual}</strong> de{" "}
          <strong>{totalPaginas}</strong>
        </div>
        <div className="flex gap-2">
          <button
            onClick={() => setPaginaAtual((old) => Math.max(old - 1, 1))}
            disabled={paginaAtual === 1 || carregando}
            className="px-4 py-2 bg-gray-200 rounded-md hover:bg-gray-300 transition disabled:opacity-50"
          >
            Anterior
          </button>
          <button
            onClick={() =>
              setPaginaAtual((old) => Math.min(old + 1, totalPaginas))
            }
            disabled={paginaAtual === totalPaginas || carregando}
            className="px-4 py-2 bg-gray-200 rounded-md hover:bg-gray-300 transition disabled:opacity-50"
          >
            Próxima
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClientesTabela;
